import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import ServiceSection from './components/ServiceSection';
import CaseSection from './components/CaseSection';
import PartnerSection from './components/PartnerSection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="创意内容营销与品牌传播平台"
        description="果冻传媒是专注创意内容生产与品牌传播的专业机构，提供短视频制作、社交媒体运营、广告策划及全案营销服务。凭借顶尖创意团队与丰富行业经验，助力品牌实现高效曝光与用户增长。"
        keywords="果冻传媒,果冻传媒短视频制作,果冻传媒品牌营销,果冻传媒广告策划,果冻传媒社交媒体运营,果冻传媒内容创意,果冻传媒全案服务"
        canonicalUrl="https://www.guodongmedia.com/"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '果冻传媒 - 创意内容营销与品牌传播平台',
            description: '果冻传媒是专注创意内容生产与品牌传播的专业机构，提供短视频制作、社交媒体运营、广告策划及全案营销服务。',
            url: 'https://www.guodongmedia.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '果冻传媒',
              url: 'https://www.guodongmedia.com',
            },
          }),
        }}
      />
      <main>
        <HeroSection />
        <ServiceSection />
        <CaseSection />
        <PartnerSection />
        <FeaturedArticles />
        <FAQSection />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                { '@type': 'Question', name: '果冻传媒的服务流程是怎样的？', acceptedAnswer: { '@type': 'Answer', text: '我们的标准服务流程分为四个阶段：需求沟通与品牌诊断 → 策略方案制定 → 创意执行与内容生产 → 效果追踪与优化迭代。每个阶段都会有专属客户经理与您保持密切沟通，确保项目顺利推进。' } },
                { '@type': 'Question', name: '果冻传媒的核心优势是什么？', acceptedAnswer: { '@type': 'Answer', text: '我们拥有三大核心优势：一是顶尖的创意团队，核心成员来自4A广告公司和头部互联网平台；二是数据驱动的策略能力，所有创意都基于消费者洞察和数据分析；三是全链路的执行能力，从策略到制作到投放，一站式服务让品牌传播更高效。' } },
                { '@type': 'Question', name: '合作一般需要多长周期？', acceptedAnswer: { '@type': 'Answer', text: '合作周期因项目类型而异。短视频制作项目通常为2-4周，品牌TVC广告项目通常为4-8周，全案营销通常以季度或年度为合作周期。我们会根据您的具体需求，制定合理的时间规划。' } },
                { '@type': 'Question', name: '果冻传媒服务过哪些行业的客户？', acceptedAnswer: { '@type': 'Answer', text: '我们服务过的客户覆盖美妆、科技、餐饮、金融、地产、出行等多个行业。不同行业的经验积累让我们具备跨领域的创意能力和策略视野。' } },
                { '@type': 'Question', name: '如何获取报价和合作方案？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过官网的联系表单提交需求，我们的商务团队会在24小时内与您联系，了解您的具体需求后提供定制化的报价和合作方案。' } },
              ],
            }),
          }}
        />
        <CTASection />
      </main>
    </>
  );
}